// @ts-ignore
import InfiniteLoading from 'v3-infinite-loading'
import 'v3-infinite-loading/lib/style.css'

export default defineNuxtPlugin(({ vueApp }) => {
  vueApp.component('InfiniteLoading', InfiniteLoading)
})
